enum PlatformType {
  WOOCOMMERCE = 'WOOCOMMERCE',
  SHOPIFY = 'SHOPIFY',
  CUSTOM = 'CUSTOM'
}

export default PlatformType;
